import React from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { Controller } from 'react-hook-form';
const EzControlledMultiSelect = (props) => {
  const {
    control,
    name,
    shouldFilter,
    filterBy,
    options,
    optionLabel,
    optionValue,
    rules,
    onChange,
    disabled,
    selectAllLabel,
    placeholder,
    emptyMessage
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <MultiSelect
          disabled={disabled}
          filter={shouldFilter}
          filterBy={filterBy || optionLabel}
          id={field.name}
          value={field.value}
          options={options}
          optionLabel={optionLabel}
          editable={true}
          optionValue={optionValue}
          placeholder={placeholder}
          emptyMessage={emptyMessage}
          display="checkbox"
  showSelectAll={true}
          selectAllLabel={selectAllLabel}
          onChange={(e) => {
            if (onChange) {
              onChange(e);
            }
            field.onChange(e.value);
          }}
        />
      )}
    />
  );
};

EzControlledMultiSelect.defaultProps = {
  optionLabel: 'label',
  optionValue: 'value',
  shouldFilter: true,
};

export default EzControlledMultiSelect;
